import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { getLineageMetaTitle } from '@/_utils/utils';
import { ClientConfig, TitleHierarchyComponent } from '@/__configs/config_types';
import { ConfigContext } from '@/contextAPI/configContext';

const TitleHierarchy: TitleHierarchyComponent = (props) => {
  const TitleHierarchyComponent: ClientConfig['titleHierarchyComponent'] = useContext(ConfigContext).titleHierarchyComponent;

  if (TitleHierarchyComponent) {
    return <TitleHierarchyComponent {...props} />;
  }

  const { title, nameFallback } = props;

  return (
    <div>
      <Typography>
        <strong>{title?.name || nameFallback}</strong>
      </Typography>
      {!!title.children?.length && (
        <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
          {getLineageMetaTitle(title.children[0], true)}
        </Typography>
      )}
    </div>
  );
};

export default TitleHierarchy;
